import * as React from "react";
import { BooleanField, Datagrid, TextField } from "react-admin";
import { CustomDateField } from "../../Components/CustomDateField";
import DataGridActions from "./DataGridActions";
import SubList from "./SubList/SubList";
import { useAuth } from "@airborne/react-admin";
export const DataGridColumns = props => {
  const { user } = useAuth();

  return (
    <Datagrid {...props} optimized hasBulkActions={false} expand={<SubList {...props} hasBulkActions={false} />}>
      <DataGridActions
        label="Actions"
        remarkAddClick={props.remarkAddClick}
        handlePDFViewer={props.handlePDFViewer}
        handleShopReportFields={props.handleShopReportFields}
      />
      <TextField source="customerCode" label="Customer" />
      <TextField source="customerPo" label="Customer Po" />
      <TextField source="refNo" label="Ref NO" />
      <TextField source="pn" label="PN" />
      <TextField source="sn" label="SN" />
      <TextField source="pnDescription" label="PN Description" />
      <CustomDateField source="scheduleStartDate" label="Schedule Start Date" />
      <TextField source="wo" label="Wo" />
      <TextField source="roNumber" label="RO" />
      <TextField source="roStatus" label="RO Status" />
      <CustomDateField source="roClosedDate" label="Ro Closed Date" />
      <TextField source="pnCondition" label="PN Condition" />
      <TextField source="faultConfirm" label="Fault Confirm" />
      <TextField source="hardTime" label="Hard Time" />
      <TextField source="vendor" label="Vendor Code" />
      {!user?.isCustomer && <BooleanField source="hasDocument" label="Has Document" />}
    </Datagrid>
  );
};

export default DataGridColumns;
